import _ from 'underscore';
import Model from 'cdna/core/model';
import Collection from 'cdna/core/collection';  

export default Model.extend({
    defaults: {
        activeView: 'faq',
        pages: []
    },
    computed: {
        'canPrint pages': function(pages) {
            var activePage = pages.findWhere({ isActive: true });
            if (!activePage)  return false;
            return activePage.get('canPrint');
        },
    },
    initialize(things, registry) {
        this.registry = registry;
        this.on('change:pages[].isActive add:pages remove:pages', this.sanitizeActive, this);
    },
    sanitizeActive(changingPage) {
        var activePages = this.get('pages').where({ isActive: true });

        //attempt to have at least one active
        if (activePages.length == 0) {
            var firstPage = this.get('pages').first();
            if (firstPage) firstPage.set('isActive', true);
            return;
        }

        //if the changing model is inactive, the only thing to worry with is ensuring at least one selection, so bail early
        if (changingPage && !changingPage.get('isActive')) return;

        //make sure there is only one marked active, preferring the changing model
        var maintain = changingPage  || _.first(activePages);
        var inactivate = _.without(activePages, maintain);
        _.each(inactivate, (page) => {
            page.set('isActive', false);
        });
    },
    addPage(type, data, title) {
        var vmType = this.registry[type].model;
        var vm = new vmType(data || {});
        vm.set('type', type);
        if (title) vm.set('Title', title);
        if (!vm.has('Id')) vm.set('Id', _.uniqueId(type));

        this.get('pages').add(vm);
    }
});


/** WEBPACK FOOTER **
 ** ./client/helpCenterModel.js
 **/